import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAccounts } from '@spotify/plugin-confidence-app-react';

/**
 * Redirect the user to the correct account if they are logged in
 * and the organization is not the same as the account given in the URL.
 */
export const AppAccountRedirect = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { selectedAccountId, switchAccount } = useAccounts();

  const shouldLogin = searchParams.get('login') === 'true';
  const organization = searchParams.get('organization') ?? undefined;

  useEffect(() => {
    if (selectedAccountId) {
      if (shouldLogin && organization) {
        if (organization !== selectedAccountId) {
          switchAccount(organization);
        }
        searchParams.delete('login');
        searchParams.delete('organization');
        setSearchParams(searchParams);
      }
    }
  }, [
    searchParams,
    setSearchParams,
    shouldLogin,
    organization,
    selectedAccountId,
    switchAccount,
  ]);

  return null;
};
